import { h } from "vue";
import {
  FieldTimeOutlined,
  PhoneOutlined,
  MailOutlined,
  WhatsAppOutlined,
  MessageOutlined,
} from "@ant-design/icons-vue";
/*import SmsIcon from "@/app/shared/components/icons/channelIcons/SmsIcon.vue";*/

import { SequenceNodeType } from "@/@types/flows/sequences";

export const IconByType = {
  [SequenceNodeType.TimeInterval]: h(FieldTimeOutlined),
  [SequenceNodeType.AutomaticCall]: h(PhoneOutlined, { rotate: 90 }),
  [SequenceNodeType.Email]: h(MailOutlined),
  [SequenceNodeType.Whatsapp]: h(WhatsAppOutlined),
  [SequenceNodeType.Sms]: h(MessageOutlined),
} satisfies Record<SequenceNodeType, unknown>;
